import { Backdrop, Box, Button, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useTheme } from "@emotion/react";
import { formatPrice } from "../../../utils";

const ViewExpenseModal = ({ open,
    handleClose,
    expense }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '40%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '80%' : '40%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isMobile ? 1 : 4,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        {/* title */}
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {t('expenseInfo')}
                        </Typography>
                        <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                    </Box>

                    {/* info text */}
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('user')}: <span style={{ fontWeight: 'bold' }}>{expense.user && expense.user.name}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('branch')}: <span style={{ fontWeight: 'bold' }}>{expense.branch && expense.branch.name}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 1 }}>
                        {t('expenseType')}: <span style={{ fontWeight: 'bold' }}>{expense.expenseType && expense.expenseType.name}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 1 }}>
                        {t('amount')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(expense.amount)}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 1 }}>
                        {t('date')}: <span style={{ fontWeight: 'bold' }}>{expense.date}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 1 }}>
                        {t('note')}: <span style={{ fontWeight: 'bold' }}>{expense.note}</span>
                    </Typography>


                    <Box sx={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        mt: 2
                    }}>
                        {/* close */}
                        <Button
                            variant="outlined"
                            color="primary"
                            sx={{ textTransform: 'none', width: 140, height: 40 }}
                            onClick={handleClose}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p>{t('close')}</p>
                                <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                            </Box>
                        </Button>

                        <Box width={20}></Box>

                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}

export default ViewExpenseModal;
